import React, { useState, useEffect, useContext } from 'react';
import firebase from "firebase/compat/app";

import axios from 'axios';
import { Input } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { styled } from '@mui/system';

import { auth, db } from "../firebase.js";
import { AlertContext } from '../AlertContext.js';


const CLOUD_FUNCTION_URL = "https://us-central1-chatbot-413809.cloudfunctions.net/fn_chatbot-with-enbedding";
const MESSAGE_LIMIT = 5;
const LIMIT_DURATION = 30000;

// スタイル付きコンポーネントの定義
const StyledInput = styled(Input)({
  width: "78%",
  fontsize: "15px",
  fontWeight: "550",
  marginLeft: "5px",
  marginBottom: "-3px",
});

const StyledSendIcon = styled(SendIcon)({
  color: "#7AC2FF",
  marginLeft: "20px",
});


const createChatSession = async (adminId) => {
  const uid = auth.currentUser.uid;
  const email = auth.currentUser.email;
  
  console.log("# createNewChatSession() called.");
  console.log("# uid: ", uid);
  console.log("# email: ", email);

  // 新しいチャットセッションドキュメントを追加
  const chatsSessionRef = await db.collection('Chats').add({
    adminId: adminId,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    participants: email,
  });
  
  console.log("# createNewChatSession() end: ", chatsSessionRef);
  // 生成されたセッションを返す
  return chatsSessionRef;
};

const SendMessage = ({ isLoading, setIsLoading, chatsRef, setChatsRef, adminId}) => {
  const [message, setMessage] = useState("");
  const [dispMessage, setDispMessage] = useState("");
  // const [isLoading, setIsLoading] = useState(false);
  const [messageCount, setMessageCount] = useState(0);
  const [timerId, setTimerId] = useState(null);
  const { timeoutOccurred, setTimeoutOccurred, isLimited, setIsLimited, errorMessage, setErrorMessage } = useContext(AlertContext);


  useEffect(() => {
    if (messageCount === 1 && timerId === null) {
      const timer = setTimeout(() => {
        setMessageCount(0);
        setIsLimited(false);
        setTimerId(null);
      }, LIMIT_DURATION);
      setTimerId(timer);
    } else if (messageCount >= MESSAGE_LIMIT) {
      setIsLimited(true);
    }
  }, [messageCount, setIsLimited, timerId]);


  // isLoading 管理用ラッパー
  const withLoading = async (asyncFunction, functionName) => {
    console.time(`処理時間 - ${functionName}`);
    setIsLoading(true);
  
    try {
      await asyncFunction();
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        console.log('リクエストがタイムアウトしました。');
        setTimeoutOccurred(true);
      } else {
        console.error('# エラー:', error);
        setErrorMessage(error.message); // エラーメッセージを設定
      }
    } finally {
      setIsLoading(false);
      console.timeEnd(`処理時間 - ${functionName}`);
    }
  };

  // メッセージ送信時 main
  const handleSubmit = async (e) => {
    console.log('# handleSubmit() called.')
    e.preventDefault();
    
    // 既にAPI呼出し中の場合、処理を受け付けない
    if (isLoading) {
      console.log('# now loding...')
      return;
    }
    
    // 実行回数が上限以上の場合、処理を受け付けない
    if (isLimited) {
      setIsLoading(false);
      return;
    }
    
    setTimeoutOccurred(false);
    setIsLoading(true);
    setMessage(dispMessage);
    setMessageCount(messageCount + 1);

    // Chats コレクションとのセッションの確認
    let _chatsRef = chatsRef;
    if (!_chatsRef) {
      console.log('ChatsRef is not available, waiting for session creation.');
      console.log('adminId: ', adminId)
      _chatsRef = await createChatSession(adminId);
      setChatsRef(_chatsRef);
      // return;
    }

    try {
      // メッセージの DB 登録
      sendMessage(_chatsRef);
      // 返信生成 API 呼出しと DB 登録
      await withLoading(async () => {
        let response = await callOpenAIAPI();
        await addMessages(_chatsRef, response);
        updateChatCollection(_chatsRef);
      }, "callOpenAIAPIAndAddMessages");
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }


  // firestore にメッセージを格納
  const sendMessage = async (ref) => {
    console.log('# sendMessage() called.');
    const { uid, photoURL } = auth.currentUser;
    const docRef = await ref;

    // メッセージを Chats コレクションのサブコレクションに追加
    await docRef.collection('Messages').add({
      text: message,
      photoURL,
      uid,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
    setDispMessage("");
  }


  // GCP Functions へのリクエスト
  const callOpenAIAPI = async () => {
    const uid = auth.currentUser.uid;
    console.log("# uid: ", uid);
    console.log("# message: ", message);

    // URLのクエリストリングからadminIdを取得
    const urlParams = new URLSearchParams(window.location.search);
    const adminId = urlParams.get('adminId');

    if (!adminId) {
      throw new Error("URLの設定が不正です。管理者にお問い合わせください。");
    }

    const body = {
      "message": message,
      "user_id": uid,
      "admin_id": adminId,
    };

    const header = {
      headers: { 'Content-Type': 'application/json' },
      timeout: 60000, // クライアントサイドのタイムアウト制御(ms)
    };
    
    const response = await axios.post(CLOUD_FUNCTION_URL, body, header);
    const data = response.data;
    console.log(data);
    return data;
  }


  // openAI に質問を投げ、firestore に格納する
  const addMessages = async (ref, response) => {
    console.time("addMessages 処理時間");
    const docRef = await ref;
    
    if (response) {
      let answer = response["response"]
      let qasIds = response["qas_ids"]
      let icon_url = response["icon_url"]
      // メッセージを Chats コレクションのサブコレクションに追加
      await docRef.collection('Messages').add({
        text: answer,
        // photoURL: "https://cdn.worldvectorlogo.com/logos/openai-2.svg",
        uid: "chatGPT",
        qasIds: qasIds,
        photoURL: icon_url,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      });  
      setMessage("");
    }

    console.timeEnd("addMessages 処理時間");
  }


  const updateChatCollection = async (ref) => {
    const docRef = await ref;
    const messagesCollection = docRef.collection('Messages');
    
    // Messageサブコレクションの全件取得
    const allMessagesSnapshot = await messagesCollection.get();
    const chatCount = allMessagesSnapshot.size;
  
    // qualityFlagが'bad'と'good'の件数を取得
    const badSnapshot = await messagesCollection.where('qualityFlag', '==', 'bad').get();
    const goodSnapshot = await messagesCollection.where('qualityFlag', '==', 'good').get();
    const bad = badSnapshot.size;
    const good = goodSnapshot.size;
  
    // Chatsコレクションの更新
    await docRef.update({
      chatCount,
      bad,
      good
    });
  }


  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="sendMsg">
          <StyledInput
            placeholder="メッセージを入力してください"
            type="text"
            onChange={(e) => {
              setDispMessage(e.target.value);
              setMessage(e.target.value);
            }}
            value={dispMessage}
          />
          <StyledSendIcon />
        </div>
      </form>
    </div>
  )
}

export default SendMessage
